var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useId, useMemo, } from 'react';
import { SystemIcon } from '@storeblocks/icon';
import { InlineAlertBase, Title } from './styled';
const typeToIcon = {
    info: 'information-filled',
    success: 'check-circle-filled',
    warning: 'warning-filled',
    error: 'error-filled',
};
function InlineAlert(_a) {
    var { title, variant = 'info', role } = _a, props = __rest(_a, ["title", "variant", "role"]);
    const icon = useMemo(() => typeToIcon === null || typeToIcon === void 0 ? void 0 : typeToIcon[variant], [variant]);
    const titleId = useId();
    return (React.createElement(InlineAlertBase, Object.assign({ "$variant": variant, "aria-labelledby": titleId }, props),
        React.createElement(SystemIcon, { name: icon, "aria-hidden": "true" }),
        React.createElement(Title, { role: role, id: titleId }, title)));
}
export default InlineAlert;
